/** @jsx jsx */
import { ReactNode } from 'react';
import { pick } from 'lodash';

import Media from '../Media';
import { jsx } from '@emotion/core';

export type PropsQueriesType = {
  [x: string]: object;
};

type PropsQueryProps = {
  /** children function that accepts props override as results */
  children: (a: { [key: string]: boolean }) => ReactNode;
  /** Object where keys are queries and properties are the props overrides
  ```
  { '(min-width: 600px)': { isFlex: true } }
  ```
  Can use theme.Screen props like
  ```
  { 'phoneOnly': { isFlex: true } }
  ```
  @default {}
   */
  queries?: PropsQueriesType;
};

/**
 * @deprecated **Hey! Listen! ✨ This component is semi-deprecated. You might want to try `useMediaProps` instead.**
 *
 * Allows overriding of children props based on media queries
 */
export const PropsQuery = ({ children, queries = {} }: PropsQueryProps) => {
  const mediaQueries = Object.keys(queries).reduce(
    (acc, query) => ({ ...acc, [query]: query }),
    {}
  );
  return (
    <Media queries={mediaQueries}>
      {(results: { [x: string]: any }) => {
        const activeResultKeys = Object.keys(results).filter(
          key => results[key]
        );
        const activeQueries = pick(queries, activeResultKeys);
        const overrides = Object.values(activeQueries).reduce(
          (acc: { [x: string]: boolean }, override: object) => ({
            ...acc,
            ...override,
          }),
          {}
        );
        return children(overrides as { [key: string]: boolean });
      }}
    </Media>
  );
};
